import { library} from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faCog,
  faThermometerFull,
  faBars,
  faUsersCog,
  faPlus,
  faTimes,
  faQuestionCircle,
  faSave,
  faAngleLeft,
  faAngleRight,
  faMinus,
  faArrowDown,
  faArrowUp,
  faUndo,
  faSearch,
  faExternalLinkAlt,
  faTrash,
  faDownload,
  faFileExcel,
  faEye,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faPalette,
  faEllipsis,
  faEllipsisV,
  faSortAlphaDownAlt,
  faSortAlphaDown,
  faHandHoldingHeart,
  faCircleNotch,
  faWaveSquare,
  faChartPie,
  faPencil, 
  faWrench, 
  faUserCircle,
  faFolder

} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHome,
  faCog, 
  faThermometerFull,
  faBars,
  faUsersCog,
  faPlus,
  faTimes,
  faQuestionCircle,
  faSave,
  faAngleLeft,
  faAngleRight,
  faMinus,
  faArrowDown,
  faArrowUp,
  faUndo,
  faSearch,
  faExternalLinkAlt,
  faTrash,
  faDownload,
  faFileExcel,
  faEye,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faPalette,
  faEllipsis,
  faEllipsisV,
  faSortAlphaDownAlt,
  faSortAlphaDown,
  faHandHoldingHeart,
  faCircleNotch,
  faWaveSquare,
  faChartPie,
  faPencil, 
  faWrench, 
  faUserCircle, 
  faFolder 
)

//FUNCION QUE RETORNA EL COMPONENTE DEL ICONO POR SU NOMBRE (ICON)
function Icon({ icon, ...rest }: { icon: string } & FontAwesomeIconProps): JSX.Element | null {
  switch (icon) {
    case "faHome":
      return <FontAwesomeIcon icon={faHome} {...rest} />;

    case "faCog":
      return <FontAwesomeIcon icon={faCog} {...rest} />;

    case "faThermometerFull":
      return <FontAwesomeIcon icon={faThermometerFull} {...rest} />;

    case "faBars":
      return <FontAwesomeIcon icon={faBars} {...rest} />;

    case "faUsersCog":
      return <FontAwesomeIcon icon={faUsersCog} {...rest} />;

    case "faPlus":
      return <FontAwesomeIcon icon={faPlus} {...rest} />;

    case "faTimes":
      return <FontAwesomeIcon icon={faTimes} {...rest} />;

    case "faQuestionCircle":
      return <FontAwesomeIcon icon={faQuestionCircle} {...rest} />;

    case "faSave":
      return <FontAwesomeIcon icon={faSave} {...rest} />;

    case "faAngleLeft":
      return <FontAwesomeIcon icon={faAngleLeft} {...rest} />;

    case "faAngleRight":
      return <FontAwesomeIcon icon={faAngleRight} {...rest} />;

    case "faMinus":
      return <FontAwesomeIcon icon={faMinus} {...rest} />;

    case "faArrowDown":
      return <FontAwesomeIcon icon={faArrowDown} {...rest} />;

    case "faArrowUp":
      return <FontAwesomeIcon icon={faArrowUp} {...rest} />;

    case "faUndo":
      return <FontAwesomeIcon icon={faUndo} {...rest} />;

    case "faSearch":
      return <FontAwesomeIcon icon={faSearch} {...rest} />;

    case "faExternalLinkAlt":
      return <FontAwesomeIcon icon={faExternalLinkAlt} {...rest} />;

    case "faTrash":
      return <FontAwesomeIcon icon={faTrash} {...rest} />;

    case "faDownload":
      return <FontAwesomeIcon icon={faDownload} {...rest} />;

    case "faFileExcel":
      return <FontAwesomeIcon icon={faFileExcel} {...rest} />;

    case "faEye":
      return <FontAwesomeIcon icon={faEye} {...rest} />;

    case "faChevronDown":
      return <FontAwesomeIcon icon={faChevronDown} {...rest} />;

    case "faChevronUp":
      return <FontAwesomeIcon icon={faChevronUp} {...rest} />;

    case "faSpinner":
      return <FontAwesomeIcon icon={faSpinner} {...rest} />;

    case "faPalette":
      return <FontAwesomeIcon icon={faPalette} {...rest} />;

    case "faEllipsis":
      return <FontAwesomeIcon icon={faEllipsis} {...rest} />;

      case "faEllipsisVertical":
        return <FontAwesomeIcon icon={faEllipsisV} {...rest} />;

      case "faSortAlphaDownAlt":
        return <FontAwesomeIcon icon={faSortAlphaDownAlt} {...rest} />;

      case "faSortAlphaDown":
        return <FontAwesomeIcon icon={faSortAlphaDown} {...rest} />;

      case "faHandHoldingHeart":
        return <FontAwesomeIcon icon={faHandHoldingHeart} {...rest} />;

      case "faCircleNotch":
        return <FontAwesomeIcon icon={faCircleNotch} {...rest} />;

    case "faWaveSquare":
      return <FontAwesomeIcon icon={faWaveSquare} {...rest} />;

    case "faChartPie":
      return <FontAwesomeIcon icon={faChartPie} {...rest} />;

      case "faPencil":
      return <FontAwesomeIcon icon={faPencil} {...rest} />;

      case "faWrench":
      return <FontAwesomeIcon icon={faWrench} {...rest} />;

      case "faFolder":
        return <FontAwesomeIcon icon={faFolder} {...rest} />;

        case "faUserCircle":
          return <FontAwesomeIcon icon={faUserCircle} {...rest} />;

      default:
      return null;
  }
};

export default Icon;